import { api } from '../providers/base-api';

export interface AppOption {
  id: number;
  name: string;
  alias?: string;
  type: string;
  subtype?: string;
  createdAt: string;
}

export async function listOptionsRequest(
  type: string,
  subtype?: string,
): Promise<AppOption[]> {
  const params: Record<string, string> = { type };
  if (subtype) params.subtype = subtype;
  const response = await api.get<AppOption[]>('/options', { params });
  return response.data;
}

export async function createOptionRequest(
  data: Pick<AppOption, 'name' | 'type' | 'subtype'>,
): Promise<AppOption> {
  const response = await api.post<AppOption>('/options', data);
  return response.data;
}
